import { Claim, ClaimControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author Atish Bagate
 */

interface Params {
  claim: Claim;
  xTENANTID?: string;
}

export const useUpdateClaims = () =>
  useMutationWithLoading(async (params: Params) =>
    new ClaimControllerApi(getConfigObject()).updateClaim(
      params.claim,
      params.xTENANTID
    )
  );

// visit history
// clinical detail
// order / prescription
// history
// documents
// forms & assessments

// color coding for start recording button
